/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

// export error key enum that can be used in client code to test specific cases
export const enum ToolingErrorKeys {
  UPLOAD_IMAGE_EXPIRED = 'ERR_UPLOAD_IMAGE_EXPIRED'
}
